import actions from './home.actions';
import mutations from './home.mutations';

export interface State {
  configuredAlert: Array<any>;
  recentAlert: Array<any>;
  applicationData: Array<any>;
  browserData: Array<any>;
  mobilerData: Array<any>;
  browserDataTotal: Number;
  mobileDataTotal: Number;
  applicationDataTotal: Number;
  endpointData: Array<any>;
  endpointDataTotal: Number;
  serviceId: string;
  loading: boolean;
  deleteWidgetId: any;
  selectedWidgetId: any;
  defaultDashBoard: any;
  selectedDashboard: any;
  applicationSpanOpen: Boolean;
}

export const initState: State = {
  configuredAlert: [],
  recentAlert: [],
  applicationData: [],
  browserDataTotal: 0,
  applicationDataTotal: 0,
  browserData: [],
  mobilerData: [],
  mobileDataTotal:0,
  endpointData: [],
  endpointDataTotal: 0,
  serviceId: '',
  loading: false,
  deleteWidgetId: '',
  selectedWidgetId: '',
  defaultDashBoard: {},
  selectedDashboard: {},
  applicationSpanOpen: false
};

// getters
const getters = {};

export default {
  namespaced: true,
  state: initState,
  getters,
  actions: actions,
  mutations: mutations
};
